import styled from "styled-components"

import { NFontWeight, NSubtitleS } from "@assets/styles/newTypographyStyles"

export const GroupName = styled(NSubtitleS)`
  color: var(--gray4);
  font-weight: ${NFontWeight.medium};
  margin: 10px 0 10px 20px;
`
